<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"> </p>
<h2 class="h2c"><a id="page_xxxi"></a><a id="fm3"></a>Abbreviations</h2>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<tbody><tr>
<td valign="top"><p class="table">Caton</p></td>
<td valign="top"><p class="tablea">Caton, “Review of Jacob Klein’s <em>Greek Mathematical Thought and the Origin of Algebra</em>”</p></td>
</tr>
<tr>
<td valign="top"><p class="table"><em>CM</em></p></td>
<td valign="top"><p class="tablea">Husserl, <em>Cartesian Meditations</em></p></td>
</tr>
<tr>
<td valign="top"><p class="table"><em>Crisis</em></p></td>
<td valign="top"><p class="tablea">Husserl, <em>The Crisis of European Sciences and Transcendental Phenomenology</em></p></td>
</tr>
<tr>
<td valign="top"><p class="table"><em>Early Writings</em></p></td>
<td valign="top"><p class="tablea">Husserl, <em>Early Writings in the Philosophy of Logic and Mathematics</em></p></td>
</tr>
<tr>
<td valign="top"><p class="table"><em>EJ</em></p></td>
<td valign="top"><p class="tablea">Husserl, <em>Experience and Judgment</em></p></td>
</tr>
<tr>
<td valign="top"><p class="table">Frege</p></td>
<td valign="top"><p class="tablea">Frege, “Review of Dr. E. Husserl’s <em>Philosophy of Arithmetic</em>”</p></td>
</tr>
<tr>
<td valign="top"><p class="table"><em>FTL</em></p></td>
<td valign="top"><p class="tablea">Husserl, <em>Formal and Transcendental Logic</em></p></td>
</tr>
<tr>
<td valign="top"><p class="table"><em>GMTOA</em></p></td>
<td valign="top"><p class="tablea">Klein, <em>Greek Mathematical Thought and the Origin of Algebra</em></p></td>
</tr>
<tr>
<td valign="top"><p class="table"><em>Ideas I</em></p></td>
<td valign="top"><p class="tablea">Husserl, <em>Ideas Pertaining to a Pure Phenomenology and to a Phenomenological Philosophy. First Book: General Introduction to a Pure Phenomenology</em></p></td>
</tr>
<tr>
<td valign="top"><p class="table"><em>ILI</em></p></td>
<td valign="top"><p class="tablea">Husserl, “Introduction to the <em>Logical Investigations</em>” (1913)</p></td>
</tr>
<tr>
<td valign="top"><p class="table"><em>LI</em></p></td>
<td valign="top"><p class="tablea">Husserl, <em>Logical Investigations</em></p></td>
</tr>
<tr>
<td valign="top"><p class="table"><em>Origin</em></p></td>
<td valign="top"><p class="tablea">Husserl, “The Origin of Geometry” (F = Fink’s edition; K = Biemel’s edition; C = Carr’s translation)</p></td>
</tr>
<tr>
<td valign="top"><p class="table"><em>PA</em></p></td>
<td valign="top"><p class="tablea">Husserl, <em>Philosophy of Arithmetic</em></p></td>
</tr>
<tr>
<td valign="top"><p class="table"><em>PHS</em></p></td>
<td valign="top"><p class="tablea">Klein, “Phenomenology and the History of Science”</p></td>
</tr>
<tr>
<td valign="top"><p class="table"><em>Prolegomena</em></p></td>
<td valign="top"><p class="tablea">Husserl, <em>Prolegomena to Pure Logic</em>, in <em>LI</em>, vol. I</p></td>
</tr>
<tr>
<td valign="top"><p class="table"><em>PRS</em></p></td>
<td valign="top"><p class="tablea">Husserl, “Philosophy as Rigorous Science”</p></td>
</tr>
<tr>
<td valign="top"><p class="table"><em>Schröder</em></p></td>
<td valign="top"><p class="tablea">Husserl, “Review of Ernst Schröder’s <em>Vorlesungen über die Algebra der Logik</em>”</p></td>
</tr>
<tr>
<td valign="top"><p class="table"><em>Semiotic</em></p></td>
<td valign="top"><p class="tablea">Husserl, “On the Logic of Signs (Semiotic)”</p></td>
</tr>
<tr>
<td valign="top"><p class="table"><em>Stumpf Letter</em></p></td>
<td valign="top"><p class="tablea">Husserl, “Letter from Edmund Husserl to Carl Stumpf”</p></td>
</tr>
<tr>
<td valign="top"><p class="table"><em>WP</em></p></td>
<td valign="top"><p class="tablea">Klein, “The World of Physics and the ‘Natural’ World”<a id="page_xxxii"></a></p></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm3.vue?3cbc8d5b